
(function () {
  "use strict";

  const ATTRIBUTE = "oppref";
  const STORAGE_KEY = "vkng_openai_oppref";
  const MAX_AGE = 30 * 24 * 60 * 60 * 1000;
  const ROOT = (window.Shopify && window.Shopify.routes.root) || "/";

  let syncPromise = null;

  function marketingAllowed() {
    return Boolean(
      window.Shopify &&
      window.Shopify.customerPrivacy &&
      window.Shopify.customerPrivacy.marketingAllowed() === true
    );
  }

  function validOppref(value) {
    return typeof value === "string" &&
      /^[A-Za-z0-9_-]{1,512}$/.test(value);
  }

  function getIncomingOppref() {
    const params = new URLSearchParams(window.location.search);
    const value = params.get("oppref");
    return validOppref(value) ? value : null;
  }

  function clearStorage() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (error) {}
  }

  function getSavedOppref() {
    try {
      const saved = JSON.parse(
        localStorage.getItem(STORAGE_KEY) || "null"
      );

      if (
        !saved ||
        !validOppref(saved.value) ||
        !Number.isFinite(saved.timestamp) ||
        saved.timestamp > Date.now() ||
        Date.now() - saved.timestamp > MAX_AGE
      ) {
        clearStorage();
        return null;
      }

      return saved.value;
    } catch (error) {
      clearStorage();
      return null;
    }
  }

  function saveOppref(value) {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          value: value,
          timestamp: Date.now()
        })
      );
    } catch (error) {}
  }

  async function updateCartAttribute(value) {
    const response = await fetch(ROOT + "cart.js", {
      credentials: "same-origin"
    });

    if (!response.ok) {
      throw new Error("Unable to read cart");
    }

    const cart = await response.json();
    const current = (cart.attributes || {})[ATTRIBUTE] || "";

    if (current === value) {
      return;
    }

    const update = await fetch(ROOT + "cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        attributes: {
          [ATTRIBUTE]: value
        }
      })
    });

    if (!update.ok) {
      throw new Error("Unable to update cart attribute");
    }
  }

  async function synchronize() {
    if (syncPromise) {
      return syncPromise;
    }

    syncPromise = (async function () {
      if (!marketingAllowed()) {
        clearStorage();
        await updateCartAttribute("");
        return;
      }

      const incoming = getIncomingOppref();
      let value = getSavedOppref();

      if (incoming) {
        value = incoming;
        saveOppref(incoming);
      }

      await updateCartAttribute(value || "");
    })();

    try {
      await syncPromise;
    } catch (error) {
      console.warn("VKNG oppref synchronization failed");
    } finally {
      syncPromise = null;
    }
  }

  function initialize() {
    if (
      !window.Shopify ||
      typeof window.Shopify.loadFeatures !== "function"
    ) {
      return;
    }

    window.Shopify.loadFeatures(
      [{
        name: "consent-tracking-api",
        version: "0.1"
      }],
      function (error) {
        if (error) return;

        synchronize();
      }
    );
  }

  document.addEventListener(
    "visitorConsentCollected",
    synchronize
  );

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize);
  } else {
    initialize();
  }
})();
